import React from 'react';
import { HeaderActions } from './HeaderActions';

export const MobileHeaderIcons: React.FC = () => {
  return <HeaderActions isMobileSidebar={true} />;
};